import styled from 'styled-components';

export const Container = styled.ul`
  display: flex;
  align-items: center;
  font-size: 0.8rem;
  background-color: var(--white_gray);
  flex-wrap: wrap;

  ul,
  li {
    display: flex;
    align-items: center;
  }

  li svg {
    width: 1rem;
    height: 1rem;
    margin: 0 0.1rem;
    color: var(--gray_medium);
    stroke-width: 0.08rem;
  }

  li:last-child {
    font-weight: 700;
    color: var(--primary_color);
    text-transform: uppercase;
  }
`;
